module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// /home/semantica-admin/production2024/web/app/themes/cedarberg-sage9/node_modules/truncate-text/index.js
// module id = 10
// module chunks = 0